import React, { createContext, useContext, ReactNode } from 'react';

const LocalStorageContext = createContext({} as PropsContextProvider);

type PropChildren = {
    children: ReactNode;
}

type PropsContextProvider = {
    saveInLocalStorage: (key: string, value: string) => void,
    getFromLocalStorage: (key: string) => string | null,
    clearLocalStorage: () => void
    saveInSessionStorage: (key: string, value: string) => void,
    getFromSessionStorage: (key: string) => string | null,
    removeItemSessionStorage: (key: string) => void,
    clearSessionStorage: () => void
}

export default function LocalStorageProvider({ children }: PropChildren) {

    return (

        <LocalStorageContext.Provider
            value={{
                saveInLocalStorage,
                getFromLocalStorage,
                clearLocalStorage,
                saveInSessionStorage,
                getFromSessionStorage,
                clearSessionStorage,
                removeItemSessionStorage
            }}>
            {children}
        </LocalStorageContext.Provider>
    )
}

export function useLocalStorage() {
    const context = useContext(LocalStorageContext);
    if (!context) throw new Error("useLocalStorage must be used within an LocalStorageProvider");
    const { saveInLocalStorage, getFromLocalStorage, clearLocalStorage, saveInSessionStorage, getFromSessionStorage, clearSessionStorage, removeItemSessionStorage } = context;
    return ({ saveInLocalStorage, getFromLocalStorage, clearLocalStorage, saveInSessionStorage, getFromSessionStorage, clearSessionStorage, removeItemSessionStorage });
}

export function saveInSessionStorage(key: string, value: string) {
    sessionStorage.setItem(key, value);
}

export function getFromSessionStorage(key: string) {
    return sessionStorage.getItem(key);
}

export function clearSessionStorage() {
    sessionStorage.clear();
}

export function saveInLocalStorage(key: string, value: string) {
    localStorage.setItem(key, value);
}

export function getFromLocalStorage(key: string) {
    return localStorage.getItem(key);
}

export function clearLocalStorage() {
    localStorage.clear();
}

export function removeItemSessionStorage(key: string) {
    sessionStorage.removeItem(key);
}